import React, { useState, useEffect, useMemo } from 'react';
import api from '../api';
import NotifySheet from './NotifySheet';

// „Pošalji obavijest” o objavi s Oglasne ploče (samo admin): zadano svi članovi, može se suziti na grupe
// i pojedince. Uvijek in-app + push; backend pamti zadnje slanje na objavi.

export default function AnnouncementNotifySheet({ announcement, user, onClose, onSent }) {
  const me = user.email;
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    api.get('/users').then(r => setUsers(r.data)).catch(() => {});
    api.get('/groups').then(r => setGroups(r.data)).catch(() => {});
  }, []);

  const sources = useMemo(() => {
    const verified = users.filter(u => u.is_verified !== false && u.email !== me);
    if (!verified.length) return [];
    const ok = new Set(verified.map(u => u.email));
    const list = [{ key: 'all', label: 'Svi članovi', people: verified.map(u => ({ email: u.email, name: u.full_name || u.email, sub: null })) }];
    for (const g of groups) {
      const people = (g.members || []).filter(m => ok.has(m.email))
        .map(m => ({ email: m.email, name: m.full_name || m.email, sub: m.role === 'owner' ? 'vlasnik grupe' : null }));
      if (people.length) list.push({ key: `g:${g.id}`, label: `Grupa ${g.name}`, people });
    }
    return list;
  }, [users, groups, me]);

  const defaultSrc = useMemo(() => ['all'], []);
  const short = announcement.text.length > 60 ? `${announcement.text.slice(0, 60)}…` : announcement.text;
  const templates = useMemo(() => {
    const t = announcement.text;
    return [
      { key: 'text', label: 'Tekst objave', text: t.slice(0, 500) },
      { key: 'reminder', label: 'Podsjetnik', text: `Podsjetnik: ${t}`.slice(0, 500) },
    ];
  }, [announcement.text]);
  const last = announcement.notified_at
    ? { at: announcement.notified_at, count: announcement.notified_count || 0, by_name: announcement.notified_by }
    : null;

  return (
    <NotifySheet
      z={1150}
      subtitle={`Oglasna ploča · „${short}”`}
      sources={sources}
      defaultSrc={defaultSrc}
      templates={templates}
      last={last}
      lastLabel="Zadnja obavijest za ovu objavu"
      emptyText="Učitavam članove…"
      note="Primatelji je vide u Obavijestima, a tko ima uključen push dobit će je i na mobitel. Dodir na obavijest otvara Oglasnu ploču."
      onSend={async (emails, message, audience) => {
        const res = await api.post(`/announcement/${announcement.id_new}/notify`, { emails, message, audience });
        return res.data;
      }}
      onSent={onSent}
      onClose={onClose}
    />
  );
}
